import * as React from 'react'

function SvgComponent(props: any) {
    return (
        <svg
            width={93}
            height={92}
            viewBox='0 0 93 92'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            {...props}>
            <path
                d='M90 28.52V6.77L68.25 28.52H90zM3 63.32v21.75l21.75-21.75H3z'
                fill='#fff'
                stroke='#000'
                strokeWidth={5}
                strokeMiterlimit={10}
            />
            <path
                d='M90 45.92c0 24.07-19.43 43.5-43.5 43.5-13.05 0-24.94-5.8-32.915-14.935M53.75 3C63.9 4.74 72.89 9.96 79.415 17.355M19.24 12.135c5.655-4.64 12.47-7.685 20.01-8.99M3 45.92c0-8.41 2.465-16.24 6.525-23.055'
                stroke='#000'
                strokeWidth={5}
                strokeMiterlimit={10}
            />
            <path
                d='M46.5 44.47a8.7 8.7 0 100-17.4 8.7 8.7 0 000 17.4z'
                fill='#300038'
                stroke='#000'
                strokeWidth={5}
                strokeMiterlimit={10}
            />
            <path
                d='M72.6 82.17v-20.3c0-6.38-5.655-11.6-12.615-11.6h-26.97c-6.96 0-12.615 5.22-12.615 11.6v1.45'
                stroke='#000'
                strokeWidth={5}
                strokeMiterlimit={10}
            />
        </svg>
    )
}

export default SvgComponent
